export function getCheckoutProductsInGtmFormat(products) {
  return products.reduce((formattedProducts, product) => {
    const formattedProduct = {
      id: product.sku,
      price: product.price,
      dimension27: product.size,
      dimension30: product.variantSku,
      quantity: product.quantity,
    }
    formattedProducts.push(formattedProduct)
    return formattedProducts
  }, [])
}

export function getHashedEmail(email) {
  if (email) return window.forge_sha256(email)
}

export function formatProduct(item) {
  return {
    id: item.sku, // Product ID (string).
    price: item.price,
    quantity: item.quantity,
    dimension27: item.size,
    dimension30: item.variantSku,
  }
}
